import { Component } from '@angular/core';
import {ProjectsService} from "../../../services/projects.service";
import {CoreService} from "../../../services/core.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-thank-you-act',
  templateUrl: './thank-you-act.component.html',
  styleUrls: ['./thank-you-act.component.sass']
})
export class ThankYouActComponent {
  constructor(
    private coreService: CoreService
  ) {
    this.coreService.enableThankYouPage();
  }
}
